var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6267 22.2263C24.9333 21.4797 23.3867 20.5063 22.12 19.253C23.5067 17.293 24.3333 14.9197 24.3333 12.3463C24.3333 5.71967 18.9467 0.333008 12.3333 0.333008C5.72001 0.333008 0.333344 5.71967 0.333344 12.333C0.333344 18.9463 5.72001 24.333 12.3333 24.333C14.9867 24.333 17.44 23.453 19.4267 21.9863C20.68 23.2663 21.6933 24.693 22.4133 26.4397C23.3867 29.173 27.5067 29.213 28.5067 26.4397C29.16 24.7597 28.3067 22.8663 26.6267 22.2263ZM19 9.66634C21.6667 12.333 21.6667 14.9997 19 17.6663C17.3733 19.293 15 16.333 12.3333 20.333C9.66668 24.333 4.33334 16.013 4.33334 12.333C4.33334 6.99967 9.66668 6.99967 12.3333 4.33301C15 1.66634 16.3333 6.99967 19 9.66634Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 12.333C8.33334 14.533 10.1333 16.333 12.3333 16.333C14.5333 16.333 16.3333 14.533 16.3333 12.333C16.3333 10.133 14.5333 8.33301 12.3333 8.33301C10.1333 8.33301 8.33334 10.133 8.33334 12.333ZM12 9.99967C12.3733 9.99967 12.6667 10.293 12.6667 10.6663C12.6667 11.0397 12.3733 11.333 12 11.333C11.6267 11.333 11.3333 11.6263 11.3333 11.9997C11.3333 12.373 11.04 12.6663 10.6667 12.6663C10.2933 12.6663 10 12.373 10 11.9997C10 10.893 10.8933 9.99967 12 9.99967Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrunch);
export default __webpack_public_path__ + "static/media/brunch.1286f62671bd1d71c154299b5ac57514.svg";
export { ForwardRef as ReactComponent };